import { Carousel, CarouselItem } from '@ixigo/iui/Carousel';
import cn from '@repo/shared/utils/cn';
import { SectionHeader } from '@/components/section-header';
import type { Whybook } from '../-api/whyBook';

export interface WhyBookItem extends Whybook {
	className?: string;
}

export function FeatureCard({ src, alt = '', className = '' }: WhyBookItem) {
	return (
		<div className={cn('h-100 w-300px rounded-20 overflow-hidden', className)}>
			<img src={src} alt={alt} className="w-full h-full object-cover" />
		</div>
	);
}

interface WhyBookSectionProps {
	itemList: Array<WhyBookItem>;
}

export function WhyBookSection({ itemList }: WhyBookSectionProps) {
	return (
		<div className="bg-primary py-20 pr-0 flex flex-col gap-y-10">
			<SectionHeader title="Why Book Cabs With ixigo?" className="pl-20" />
			<Carousel scrollSnapAlign="start" autoPlayDuration={3000} gap={'0'}>
				{itemList.filter(Boolean).map((item) => (
					<CarouselItem key={item.src} className="last:mr-20 pl-20">
						<FeatureCard {...item} />
					</CarouselItem>
				))}
			</Carousel>
		</div>
	);
}
